export function inArray(target, array) {
	/* Caching array.length doesn't increase the performance of the for loop on V8 (and probably on most of other major engines) */
	for (let i = 0; i < array.length; i++) {
		if (array[i] === target) {
			return true;
		}
	}
	return false;
}

/**
 createNestedObject( window, ["shapes", "circle"] );
 // Now window.shapes.circle is an empty object, ready to be used.
 createNestedObject( window, ["shapes", "rectangle", "width"], 300 );
 // Now we have: window.shapes.rectangle.width === 300
 * @param base
 * @param names
 * @link https://stackoverflow.com/questions/5484673/javascript-how-to-dynamically-create-nested-objects-using-object-names-given-by#answer-11433067
 */
export function createNestedObject( base, names, value ) {
	// If a value is given, remove the last name and keep it for later:
	let lastName = arguments.length === 3 ? names.pop() : false;

	// Walk the hierarchy, creating new objects where needed.
	// If the lastName was removed, then the last object is not set yet:
	for( let i = 0; i < names.length; i++ ) {
		base = base[ names[i] ] = base[ names[i] ] || {};
	}

	// If a value was given, set it to the last name:
	if( lastName ) base = base[ lastName ] = value;

	// Return the last object in the hierarchy:
	return base;
}

/**
 *
 * @param thing
 * @param opts
 * @link https://gist.github.com/gdibble/e429544ab8fa931055b2f02a1ec5739d
 */
export function clone(thing, opts) {
    var newObject = {};
    if (thing instanceof Array) {
        return thing.map(function (i) { return clone(i, opts); });
    } else if (thing instanceof Date) {
        return new Date(thing);
    } else if (thing instanceof RegExp) {
        return new RegExp(thing);
    } else if (thing instanceof Function) {
        return opts && opts.newFns ?
            new Function('return ' + thing.toString())() :
            thing;
    } else if (thing instanceof Object) {
        Object.keys(thing).forEach(function (key) {
            newObject[key] = clone(thing[key], opts);
        });
        return newObject;
    } else if ([ undefined, null ].indexOf(thing) > -1) {
        return thing;
    } else {
        if (thing.constructor.name === 'Symbol') {
            return Symbol(thing.toString()
                .replace(/^Symbol\(/, '')
                .slice(0, -1));
        }
        // return _.clone(thing);  // If you must use _ ;)
        return thing.__proto__.constructor(thing);
    }
}

/**
 * Gets result from string path or array
 * @param object    the source
 * @param path  the string path or array
 * @returns {*}
 */
export function getByPath(object, path) {
	if (typeof path === "string") {
		path = path.split(".");
	}

	if (!(path instanceof Array) || path.length === 0) {
		return;
	}

	path = path.slice();

	let key = path.shift();

	if (typeof object !== "object" || object === null) {
		return;
	}

	if (path.length === 0) {
		return object[key];
	}

	if (path.length) {
		return getByPath(object[key], path);
	}
};



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/arraysAndObjects.js